import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Output, OnInit, Input, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { OEM_ID } from 'src/app/utils/constants';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import { SpinnerService } from 'src/app/services/shared/spinner.service';
import { OemService } from 'src/app/services/oem/oem.service';
import { ViewChild, ElementRef } from '@angular/core';
import Swal from 'sweetalert2';
import { UserDetails } from 'src/app/models/authData';
import { BreadcrumbService } from 'src/app/services/shared/breadcrumb.service';


@Component({
  selector: 'app-company-profile',
  templateUrl: './company-profile.component.html',
  styleUrls: ['./company-profile.component.scss']
})
export class CompanyProfileComponent implements OnInit {
 @Input() isPopUpVisible!: boolean 
 isCertificatePopUpVisible: boolean=false;
 @Output() closePopUpEvent = new EventEmitter<void>();
  selectedTab: number = 0;
  showTabs: boolean = true;
  companyForm!: FormGroup;
  isSave:boolean=true;
  isNotGet:boolean=false;
  isDelete:boolean=false;
  companyData:any
  oemId:string='';
  name:string='';
  userData!: UserDetails;
  remarks:string='';
  isProceed:boolean=false;
  @Output() selectedTabEvent = new EventEmitter<number>();
  @ViewChild('tabGroup', { static: false }) tabGroup!: ElementRef;
  status: string | undefined;
  notUpdatedCompanyData:any;
  existedSelectedIds: any[] = [];

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder,private http: HttpClient ,
     private localStorageService: LocalStorageService,private sweetAlertService: SweetAlertService,
      private spinnerService: SpinnerService,private oemService:OemService,private renderer: Renderer2,private breadcrumbService: BreadcrumbService
    ) {}

  ngOnInit(): void {
    if(this.isPopUpVisible){
      this.isCertificatePopUpVisible = true;
    }
  
    this.scrollToSelectedTab();
    this.initializeCompanyForm();
    const id = this.localStorageService.getItem(OEM_ID);
    this.oemId = id;
    this.localStorageService.getUserDetails().subscribe(data => {
      this.name = data.userName;
      this.status = data.status;
      
    });
    this.spinnerService.showSpinner();
    this.update(id); 
    this.spinnerService.hideSpinner();
    if (localStorage.getItem('isPopupVisible')) {
      this.isPopUpVisible = localStorage.getItem('isPopupVisible') === 'true' ? true : false;  
    } 
    this.localStorageService.getUserDetails().subscribe(userDetails => { 
      this.userData = userDetails;
    });
    this.breadcrumbService.setBreadcrumbs(['Company Profile', 'Company Information']);
    
  }

  get firstName(): string {
    return this.name || '';
  }

  proceed() {
    this.isProceed = true;
  }
  

  submitForApproval(): void {
    this.isPopUpVisible = false;
    this.closePopUpEvent.emit();
     
  }

  informationFields = [
    { name: 'userName', label: 'User Name' },
    { name: 'email', label: 'Email' },
    { name: 'uniqueId', label: 'Unique ID' },
    { name: 'name', label: 'Name' },
    {name:'phoneNumber',label:'Phone Number'},
    {name:'brandName',label:'Brand Name'},
    {name:'crcopy',label:'CR Copy'},
    { name: 'year', label: 'Year' },
    { name: 'url', label: 'URL' },
    { name: 'employeeCount', label: 'Employee Count' },
    { name: 'continent', label: 'Continent' },
    { name: 'country', label: 'Country' },
    { name: 'state', label: 'State' },
    { name: 'city', label: 'City' },
    { name: 'address', label: 'Address' },
    { name: 'zipCode', label: 'Zip Code' }
  ];

  
validateInformationFields(): boolean {
  let isValid = true;
  const requiredFields = [
    'userName', 'email', 'phoneNumber', 'logo', 'name', 'brandName', 
    'year', 'url', 'employeeCount', 'continent', 'country', 'state', 'city', 
    'address'
  ];
  this.informationFields.forEach(field => {
          const control = this.companyForm.get(`companyInformation.${field.name}`);
          if (['url', 'zipCode', 'address', 'city', 'state', 'country', 'continent', 'employeeCount'].includes(field.name)) return;
          if (this.isPopUpVisible) {
            if (this.selectedTab === 0 && 
                !(field.name === 'crcopy') && !(field.name=='businessLicense')) {
                  if (control && (control.value === null || control.value === '')) {
                    isValid = false;
                    // allFieldsFilled = false;
                    control.markAsTouched();
                    control.setErrors({ required: true });
                  }
            }
            if (this.selectedTab === 1) {
              if (control && (control.value === null || control.value === '')) {
                isValid = false;
                // allFieldsFilled = false;
                control.markAsTouched();
                control.setErrors({ required: true });
              }
            }
          } else {
    
            if (this.selectedTab === 0) {
              if (control && (control.value === null || control.value === '')) {
                if(field.name !== "businessLicense"){
                  isValid = false;
                  // allFieldsFilled = false;
                  control.markAsTouched();
                  control.setErrors({ required: true });
                }
              }
            }
          }
        });
  requiredFields.forEach(field => {
    if (field === 'zipCode') return;
    const control = this.companyForm.get(`companyInformation.${field}`);
    
    if (control && ( control?.hasError('pattern') || control?.hasError('maxlength') || control?.hasError('required'))) {
      isValid = false;
      control.markAsTouched();
      // control.setErrors({ required: true });
    }
    if (!isValid) {
      this.sweetAlertService.showError('Validation Error', 'Please fill in all required fields.');
    }
  });

  const logoControl = this.companyForm.get('companyInformation.logo');
  if (this.selectedTab === 0 && (!logoControl || !logoControl.value)) {
    isValid = false;
    this.sweetAlertService.showError('Error', 'Please upload a logo.');
  }

  const addedPOCs = (this.companyForm.get('pointOfContactWithOEMManagement.addedPOCs') as FormArray).controls;
  
  if ((this.isPopUpVisible && this.selectedTab === 4) || (!this.isPopUpVisible && this.selectedTab === 3)) {
    if (addedPOCs.length === 0) {
      isValid = false;
      this.sweetAlertService.showError('Error', 'Please provide at least one point of contact.');
    }
  }

  const productCategories = (this.companyForm.get('productCategories') as FormArray).controls;
  
  if (!this.isPopUpVisible && this.selectedTab >= 4) {
    if (productCategories.length === 0) {
      isValid = false;
      this.sweetAlertService.showError('Error', 'Please provide at least one category.');
    }
  }
  return isValid;
}

  update(id?: string) {
    if (!id) return;

  
    this.spinnerService.showSpinner();
    this.oemService.getOemWithManagementId(id).subscribe(
      data => {
        if (data?.data) {
          this.companyData = data.data;
          this.remarks=this.companyData.companyInformation.remarks
          if (this.companyData.companyInformation.status !== this.status) {
            this.localStorageService.getUserDetails().subscribe(userDetails => {
              userDetails.status = this.companyData.companyInformation.status;
              this.status = this.companyData.companyInformation.status;
              this.localStorageService.updateUserDetails(userDetails);
            });
            if (this.status === 'INCOMPLETE') {
              this.isPopUpVisible = true;
              localStorage.setItem('isPopupVisible', 'true');           
            } 
          }
          this.companyForm.patchValue(this.companyData);
          this.companyForm.get('companyInformation')?.get('email');
          this.companyForm.get('companyInformation')?.get('uniqueId')?.disable();
          this.companyForm.get('companyInformation')?.get('distributors')?.setValue(true);
          this.updateBranches();
          this.updateProductCategorys();
          this.updatedistributorsNetwork();
          this.updatefinancials();
          this.updatePointOfContacts();
          this.updatePhotos();
          this.updateVideo();
          this.notUpdatedCompanyData = this.companyForm?.value
        }
        this.spinnerService.hideSpinner();
      },
      error => {
        this.spinnerService.hideSpinner();
        Swal.fire('Error','Something went wrong. Please try again.', 'error');
      }
    );
  }
  updatePhotos() {
    const photosFormArray = this.companyForm.get('photos') as FormArray;
      photosFormArray.clear();
    
      const photosToLoad =this.notUpdatedCompanyData?.photos && this.notUpdatedCompanyData.photos.length > 0? this.notUpdatedCompanyData.photos
      : this.companyData?.photos;
        
      
      if (photosToLoad && photosToLoad.length > 0) {
      photosToLoad.forEach((photo: string) => {
        photosFormArray.push(this.fb.control(photo));
      });
      
    }
    
  }
  updateVideo() {
    const videoArray = this.companyForm.get('videos') as FormArray;
    videoArray.clear();
    const videoToLoad =this.notUpdatedCompanyData?.videos && this.notUpdatedCompanyData.videos.length > 0? this.notUpdatedCompanyData.videos
    : this.companyData?.videos;
      
    if (videoToLoad && videoToLoad.length > 0) {
      videoToLoad.forEach((video: string) => {
        videoArray.push(this.fb.control(video));
      })
    }
 
  }
updatePointOfContacts() {
  if (this.companyData?.pointOfContactWithOEMManagement?.addedPOCs && this.companyData.pointOfContactWithOEMManagement.addedPOCs.length > 0) {
    const pointOfContacts = this.companyData.pointOfContactWithOEMManagement.addedPOCs.map((obj: any) => {
      return this.fb.group({
        id: new FormControl(obj.id),
        oemId: new FormControl(obj.oemId),
        address: new FormControl(obj.address),
        positionId: new FormControl(obj.positionId),
        employeeName: new FormControl(obj.employeeName),
        employeePosition: new FormControl(obj.employeePosition),
        phone: new FormControl(obj.phone),
        email: new FormControl(obj.email),
        continent: new FormControl(obj.continent),
        country: new FormControl(obj.country),
        state: new FormControl(obj.state),
        city: new FormControl(obj.city),
        distributorId: new FormControl(obj.distributorId),
        active: new FormControl(obj.active),
        createdBy: new FormControl(obj.createdBy),
        createdOn: new FormControl(obj.createdOn),
        modifiedBy: new FormControl(obj.modifiedBy),
        modifiedOn: new FormControl(obj.modifiedOn),
        phoneCode: new FormControl(obj.phoneCode),
       
      });
    });

    const pointOfContactsFormArray = this.companyForm.get('pointOfContactWithOEMManagement')?.get('addedPOCs') as FormArray;
    if (pointOfContactsFormArray) {
      pointOfContactsFormArray.clear();
      pointOfContacts.forEach((pointOfContact: FormGroup) => {
        pointOfContactsFormArray.push(pointOfContact);
      });
    }
  }
}

updatefinancials() {
  if (this.companyData?.financialInformation && this.companyData.financialInformation.length > 0) {
    const financialInformation = this.companyData.financialInformation.map((obj: any) => {
      return this.fb.group({
        
        oemId: new FormControl('3d5325c9-0389-4285-b9a6-9d91f8b43480'),
        financialInfoId: new FormControl(obj.financialInfoId),
        financialYear: new FormControl(obj.financialYear),
        currency: new FormControl(obj.currency),
        netWorth: new FormControl(obj.netWorth),
        turnover: new FormControl(obj.turnover),
        profit: new FormControl(obj.profit),
        yearOfGrowth: new FormControl(obj.yearOfGrowth),
      });
    });

    const financialsFormArray = this.companyForm.get('financialInformation') as FormArray;
    financialsFormArray.clear();
    financialInformation.forEach((financial: FormGroup) => financialsFormArray.push(financial));
  }
}

updateProductCategorys() {
  if (this.companyData?.productCategories && this.companyData.productCategories.length > 0) {
    const productCategories = this.companyData.productCategories.map((category: string) => {
      return this.fb.control(category);
    });

    const productCategoriesFormArray = this.companyForm.get('productCategories') as FormArray;
    productCategoriesFormArray.clear();
    productCategories.forEach((category: FormControl) => productCategoriesFormArray.push(category));
  }
}
  updateBranches() {
    if (this.companyData?.branches && this.companyData.branches.length > 0) {
      const branches = this.companyData.branches.map((obj: any) => {
        return this.fb.group({
          branchId: new FormControl(obj.branchId),          
          oemId: new FormControl(obj.oemId),
          brandName: new FormControl(obj.brandName),
          address: new FormControl(obj.address),
          contactPerson: new FormControl(obj.contactPerson),
          contactPhone: new FormControl(obj.contactPhone),
          contactEmail: new FormControl(obj.contactEmail),
        });
      });

      const branchesFormArray = this.companyForm.get('branches') as FormArray;
      branchesFormArray.clear();
      branches.forEach((branch: FormGroup) => branchesFormArray.push(branch));
    }
  }
  updatedistributorsNetwork() {

    if (this.companyData?.distributorNetwork) {
        const distributorNetwork = this.companyData.distributorNetwork;
        if (distributorNetwork.selectedIds && distributorNetwork.selectedIds.length > 0) {
            const selectedIdsFormArray = this.companyForm.get('distributorNetwork.selectedIds') as FormArray;
            selectedIdsFormArray.clear();
            distributorNetwork.selectedIds.forEach((obj: any) => {
                selectedIdsFormArray.push(this.fb.control(obj));
            });
        }
        if (distributorNetwork.removedIds && distributorNetwork.removedIds.length > 0) {
            const removedIdsFormArray = this.companyForm.get('distributorNetwork.removedIds') as FormArray;
            removedIdsFormArray.clear();
            distributorNetwork.removedIds.forEach((obj: any) => {
                removedIdsFormArray.push(this.fb.control(obj));
            });
        }
    }
}
phoneValidator(control: AbstractControl) {
  const value = control.value;
  if (!value) return null; 

  const pattern = /^[0-9\(\)\-]+$/; 

  if (!pattern.test(value)) {
    return { pattern: true };
  }

  if (value.length < 5) {
    return { minlength: true };
  }

  if (value.length > 15) {
    return { maxlength: true };
  }
  return null; 
}

  initializeCompanyForm() {
    this.companyForm = this.fb.group({
      oemId: ['', Validators.required],
      companyInformation: this.fb.group({
        userName: ['',[Validators.required, Validators.maxLength(50)]],        
        firstName: [''],
        lastName: [''],
        createdBy: [''],
        email: ['', [Validators.required, Validators.email,Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]],
        oemId: ['', Validators.required],
        phoneNumber: ['', [Validators.required,this.phoneValidator]],
        phoneCode: ['', Validators.required],
        uniqueId: ['', Validators.required],
        year: [0, [Validators.required, Validators.maxLength(4),Validators.minLength(4), Validators.pattern("^[0-9]{4}$")]],
        name: ['', [Validators.required, Validators.maxLength(150)]],
        status: ['', Validators.required],
        employeeCount: [0, [Validators.maxLength(10)]],
        continent: ['',],
        country: ['', ],
        state: ['', ],
        city: ['', ],
        address: ['', []],
        zipCode: [''],
        logo: ['', Validators.required],
        url: ['', [Validators.pattern('^(https?:\/\/|www\.)[a-zA-Z0-9./]+$'), Validators.maxLength(150)]],
        brandName: ['', [Validators.required, Validators.maxLength(150)]],
        crcopy: ['', Validators.required],
        businessLicense: [''],
        cecopy: ['', Validators.required],
        otherFiles: ['', Validators.required],
        europeanCertificate: ['', Validators.required],
        subscriptionInfoId: ['', Validators.required],
        distributors: [true, Validators.required],
        description : ['', Validators.required],
        branchesPresent: ['', Validators.required],
      }),
      branches: this.fb.array([]),
      financialInformation: this.fb.array([]),
      productCategories: this.fb.array([], Validators.required),
      distributorNetwork: this.fb.group({
        selectedIds: this.fb.array([]),
        removedIds: this.fb.array([]),
      }),
      pointOfContactWithOEMManagement: this.fb.group({
        addedPOCs: this.fb.array([]),
        deletedPOCs: this.fb.array([]),
      }),

      photos: this.fb.array([]),
      videos: this.fb.array([]),
    });
  }
 
  get pointOfContacts() {
    return this.companyForm.get('pointOfContactWithOEMManagement') as FormGroup;
  }
  get productCategorys() {
    return this.companyForm.get('productCategories') as FormArray;
  }
  get distributorNetwork() {
    return this.companyForm.get('distributorNetwork') as FormGroup;
  }
  handleBranchAdded(event: number) {
    if (event === 1) {
      this.isSave=true;
      this.isNotGet=false;
      this.isDelete=false;
      this.save();
    }
    else if (event === 2) {
      this.isNotGet=true;
      this.isSave=false;
      this.isDelete=false;
      this.save();
    }
    else if(event === 3){
      this.isNotGet=true;
      this.isDelete=true;
      this.save();
    }
  }
  

  save() {

    if(this.validateInformationFields()){
      const oemId = this.localStorageService.getItem(OEM_ID)
      const branches = this.companyForm.get('branches') as FormArray;
      branches.controls.forEach((control: AbstractControl) => {
        const branch = control as FormGroup;
        branch.get('oemId')?.setValue(oemId);
      });
      const financials = this.companyForm.get('financialInformation') as FormArray;
      financials.controls.forEach((control: AbstractControl) => {
        const financial = control as FormGroup;
        financial.get('oemId')?.setValue(oemId);
      });
    
      
      const pointOfContacts = this.companyForm.get('pointOfContactWithOEMManagement.addedPOCs') as FormArray;
      pointOfContacts.controls.forEach((control: AbstractControl) => {
        const pointOfContact = control as FormGroup;
        pointOfContact.get('oemId')?.setValue(oemId);
      });
      this.companyForm.get('companyInformation')?.get('email')?.enable();
      this.companyForm.get('companyInformation')?.get('uniqueId')?.enable();
      this.notUpdatedCompanyData = this.companyForm?.value;
    
      this.oemService.oemWithManagementUpdate(this.companyForm.value)
        .subscribe(
          (data) => {
            this.userData.userName = this.companyForm.get('companyInformation')?.get('userName')?.value;
            this.localStorageService.updateUserDetails(this.userData);
            if(this.isDelete){
              this.sweetAlertService.showSuccess('', 'Deleted successfully !!')
              this.isDelete=false
            }
           else if(!this.isSave){
            this.sweetAlertService.showSuccess('', 'Updated successfully !!')
            this.isSave=true
            this.update(this.oemId);
            
           }
           else{
            this.sweetAlertService.showSuccess('', 'Saved successfully !!').then(()=>{
              this.navigateNext();
            })
           }

            if(!this.isNotGet){
              this.spinnerService.showSpinner();
            this.update(this.oemId);
            this.spinnerService.hideSpinner();

            }
            
          },
            
          (error) =>   
            this.sweetAlertService.showError('', 'Failed to update !!'),
        );
      }
    
   
  }

  ngAfterViewInit(): void {
    if (this.selectedTab === 0) {
      this.scrollToTop();
    }
  }

  isRestrict: boolean = false;
  restrictTab(index: number) {
    const productCategorys = (this.companyForm.get('productCategories') as FormArray).controls;
    let isValid = true;
    if(index>=5 && productCategorys.length === 0){
      this.sweetAlertService.showError('Error', 'Please provide at least one category');
      this.isRestrict = true;
      isValid = false;
    }
    else{
      this.isRestrict = false;
      isValid = true;
    }
  }

  scrollToTop() {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  }
  prevTab: number = 0;
  changeTab(index: number) {
    if (!this.validateInformationFields()) {
      this.sweetAlertService.showError('', 'Please fill required fields before switching tabs.');
      return;
    }
    this.companyForm?.patchValue(this.notUpdatedCompanyData);
    this.existedSelectedIds = this.notUpdatedCompanyData?.productCategories;
    this.prevTab = index;
    if(this.prevTab<this.selectedTab){
      this.selectedTab = this.prevTab;
    }
    if(this.validateInformationFields()){
      this.selectedTab = index;   
      this.updatePhotos(); 
    this.updateVideo();}
     this.scrollToSelectedTab();
     if (this.selectedTab == 0) {
      this.scrollToTop();
    }
    this.changeTabSetBreadcrumbs(this.selectedTab);
  }

  private scrollToSelectedTab() {
    setTimeout(() => {
      const tabs = this.tabGroup?.nativeElement?.querySelectorAll('.tab');
      if (tabs && tabs[this.selectedTab]) {
        tabs[this.selectedTab].scrollIntoView({ behavior: 'smooth', inline: 'center' });
      }
    }, 0);
  }

  navigateNext() {
    const maxTabIndex = this.isPopUpVisible ? 7 : 6;
    if (this.selectedTab < maxTabIndex && this.validateInformationFields()) {
      this.selectedTab++;
      this.selectedTabEvent.emit(this.selectedTab);
    }
    this.scrollToSelectedTab();
  }

  updateProductCategories(categories: any[]) {
    const productCategories = this.fb.array(categories.map(category => this.fb.control(category)));
    this.companyForm.setControl('productCategories', productCategories);
  }
  onUpdateEvent() {
    
    this.save();
  }

  handleProductCategories(event: any){
    this.existedSelectedIds = event[1];
  }
  changeTabSetBreadcrumbs(tab: any): void {
    switch (tab) {
      case 0:
        this.breadcrumbService.setBreadcrumbs(['Company Profile', 'Company Information']);
        break;
      case 1:
          this.breadcrumbService.setBreadcrumbs(['Company Profile', 'Company Description']);
        break;
      case 2:
        this.breadcrumbService.setBreadcrumbs(['Company Profile', 'Branches Information']);
        break;
      case 3:
        this.breadcrumbService.setBreadcrumbs(['Company Profile', 'Point of Contacts']);
        break;
      case 4:
        this.breadcrumbService.setBreadcrumbs(['Company Profile', 'Product Categories']);
        break;
      case 5:
        this.breadcrumbService.setBreadcrumbs(['Company Profile', 'Distribution Network']);
        break;
      case 6:
        this.breadcrumbService.setBreadcrumbs(['Company Profile', 'Financial Information']);
        break;
    }
  }
}
